export default __webpack_public_path__ + "static/media/pantry1-afterA-1024w.fc3611d2.webp";